
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50","width":"250","height":"250"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25 .256c-13.807 0-25 11.193-25 25 0 12.534 9.233 22.883 21.264 24.69V31.883h-6.186V25.31h6.186v-4.372c0-7.24 3.527-10.419 9.544-10.419 2.882 0 4.406.214 5.127.312v5.736h-4.104c-2.555 0-3.447 2.422-3.447 5.151v3.592h7.486l-1.015 6.572h-6.47V50C40.585 48.344 50 37.911 50 25.256c0-13.807-11.193-25-25-25z","fill":"#fff"}})])
          )
        }
      }
    